import React from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TC_Footer: React.FC = () => {
    const { t } = useLang('footer');

    return (
        <div className={css.comp}>
            <div className="box">{t('footer')}</div>
        </div>
    );
};

export default TC_Footer;
